"use client";

import { Alert, Button } from '@mui/material';
import { useTranslations } from 'next-intl';
import React, { useState } from 'react';
interface UsageWarningBannerProps {
  percentageUsed: number;
  onUpgradeClick?: () => void;
}
const UsageWarningBanner: React.FC<UsageWarningBannerProps> = ({
  percentageUsed,
  onUpgradeClick
}) => {
  const t = useTranslations('apiKeys');
  const [dismissed, setDismissed] = useState(false);

  // Don't show if below 50% or dismissed (except at 100%)
  if (percentageUsed < 50) return null;
  if (dismissed && percentageUsed < 100) return null;
  const getSeverity = (): 'error' | 'warning' | 'info' => {
    if (percentageUsed >= 100) return 'error';
    if (percentageUsed >= 80) return 'warning';
    return 'info';
  };
  const getMessage = (): string => {
    if (percentageUsed >= 100) return t('usageWarning100');
    if (percentageUsed >= 80) return t('usageWarning80');
    return t('usageWarning50');
  };
  const isDismissible = percentageUsed < 100;
  return <Alert severity={getSeverity()} onClose={isDismissible ? () => setDismissed(true) : undefined} sx={{
    mb: 3,
    borderRadius: '8px'
  }} action={percentageUsed >= 100 && onUpgradeClick ? <Button size="small" onClick={onUpgradeClick} sx={{
    textTransform: 'none',
    minWidth: '44px',
    minHeight: '44px'
  }}>
            {t('upgradeNow')}
          </Button> : undefined} data-sentry-element="Alert" data-sentry-component="UsageWarningBanner" data-sentry-source-file="UsageWarningBanner.tsx">
      {getMessage()}
    </Alert>;
};
export default UsageWarningBanner;